import firebase from "firebase";
import { gamesCollection, currentCollection } from "@/main";



export const admin = {
  state: {
    adminUID: null,
    adminError: null,
  },

  mutations: {
    setAdminUID(state, payload) {
      state.adminUID = payload;
    },
    setAdminError(state, payload) {
      state.adminError = payload;
    },
  },
  actions: {
    AdminSignIn({ commit }, payload) {
      // alert(JSON.stringify(payload));
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(response => {

          firebase.auth().currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            if (!!idTokenResult.claims.admin) {
              commit("setAdminUID",response.user.uid);
              commit("setAdminError",null);
              commit("auth/initUser", {
                uid: response.user.uid,
                displayName: "Administrator",
                error: null
              }, {root: true});
            } else {
              commit("setAdminUID", null);
              commit("setAdminError","You don't have admin priviledges!")
            }
          })
        })
        .catch(error => {
          commit("setAdminError", error.message);
          alert(error.message);
        });
    },
  },
  getters: { 
    adminUID(state) {
      return state.adminUID;
    }
  }
}